import { GET_ALL_REDES, KEY } from "../../Graphql/QUERIES";
import PageContainer from "../../components/PageContainer";
import TopBar from "../../components/TopBar";
import { useEffect } from "react";
import { useTheme } from "../../hooks/useTheme";

import { translateColorByRedeId } from '../../colors'
import { Typography } from "@material-ui/core";

import { useStyles } from './styles';
import RedeCard from "../../components/RedeCard";
import waveBottomImg from '../../assets/wave2.png';
import BottomBar from "../../components/BottomBar";
import { useQuery } from "@apollo/client";

function Redes() {
  const { changeTheme } = useTheme();
  const classes = useStyles();
  useEffect(() => {
    changeTheme();
  }, [])
  const { loading, error, data } = useQuery(GET_ALL_REDES, {
    variables: { token: KEY },
  }) 

  if (loading) return (
    <>
      <TopBar>
        <Typography variant="h1">
          Serviços
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography variant="body1" color="textPrimary">
            Carregando...
          </Typography>
        </div>
      </PageContainer>
      <div className={classes.waveBottom}>
        <img src={waveBottomImg} alt="onda"/>
      </div>
      <BottomBar/>
    </>
  )

  if (error) return (
    <>
      <TopBar>
        <Typography variant="h1">
          Serviços
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography variant="body1" color="textPrimary">
            Ops! Parece que ocorreu um erro.
            Tente novamente mais tarde.
          </Typography>
        </div>
      </PageContainer>
      <div className={classes.waveBottom}>
        <img src={waveBottomImg} alt="onda"/>
      </div>
      <BottomBar/>
    </>
  )

  return(
    <>
      <TopBar>
        <Typography variant="h1">
          Serviços
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography variant="body1" color="textPrimary">
            Aqui você encontra serviços dirigidos ao público 60+. Eles estão divididos nas seguintes categorias:
          </Typography>
          <div className={classes.services}>
            {data.TipoRedeAll.map(rede => {
              return (
                <RedeCard 
                  key={rede.id}
                  color={translateColorByRedeId(String(rede.id))} 
                  service={rede.nome}
                  path={`/redes/${rede.id}`}
                />
              )
            })}
          </div>
        </div>
      </PageContainer>
      <div className={classes.waveBottom}>
        <img src={waveBottomImg} alt="onda"/>
      </div>
      <BottomBar/>
    </>
  );
}

export default Redes;